import {
  Action,
  ActionType,
} from "models/stressCheck/sendHighStressNotification";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface SendHighStressNotificationReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  sendHighStressNotificationResponse?: IResponse;
}

const defaultState: SendHighStressNotificationReducerType = {
  loading: false,
  error: null,
  saved: false,
  sendHighStressNotificationResponse: undefined,
};

export const sendHighStressNotificationReducer =
  createReducer<SendHighStressNotificationReducerType>(defaultState, {
    [ActionType.SEND_HIGH_STRESS_NOTIFICATION](
      state: SendHighStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.SEND_HIGH_STRESS_NOTIFICATION_ERROR](
      state: SendHighStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.SEND_HIGH_STRESS_NOTIFICATION_SUCCESS](
      state: SendHighStressNotificationReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        sendHighStressNotificationResponse: action.payload,
      };
    },

    [ActionType.RESET_SEND_HIGH_STRESS_NOTIFICATION](
      state: SendHighStressNotificationReducerType
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        sendHighStressNotificationResponse: undefined,
      };
    },
  });
